import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--cta-long",
  "use": "icon-arrow--cta-long-usage",
  "viewBox": "0 0 47 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 47 14\" id=\"icon-arrow--cta-long\"><path d=\"M39.853 2.02L44.833 7m-4.98 4.98L44.833 7m-43 0h41.882\" stroke=\"currentColor\" stroke-width=\"1.8\" fill=\"none\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol